<template>
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9258_104830)">
      <path
        d="M2.125 0.854492H9.5625C10.0322 0.854492 10.4824 1.04095 10.8145 1.37305C11.1465
        1.70514 11.333 2.15535 11.333 2.625V6.16699H14.875C15.3447 6.16699 15.7949 6.35345
        16.127 6.68555C16.459 7.01764 16.6455 7.46785 16.6455 7.9375V15.375C16.6455 15.8447
        16.459 16.2949 16.127 16.627C15.7949 16.959 15.3447 17.1455 14.875
        17.1455H7.4375C6.96785 17.1455 6.51764 16.959 6.18555 16.627C5.85345 16.2949
        5.66699 15.8447 5.66699 15.375V11.833H2.125C1.65535 11.833 1.20514 11.6465
        0.873047 11.3145C0.540951 10.9824 0.354492 10.5322 0.354492 10.0625V2.625C0.354492
        2.15535 0.540951 1.70514 0.873047 1.37305C1.20514 1.04095 1.65535 0.854492 2.125
        0.854492ZM11.333 10.4668H11.9688C11.7363 10.9795 11.4611 11.4309 11.1436
        11.8311C11.0917 11.7679 11.0395 11.7049 10.9902 11.6396L10.793 11.3779L10.5176
        11.5547C10.2675 11.7145 9.98062 11.8088 9.68457 11.8291L9.08789 11.8701L9.41113
        12.373C9.55383 12.5957 9.70598 12.809 9.86621 13.0137C9.17043 13.485 8.33153
        13.8496 7.34668 14.1113L6.81445 14.2529L7.16406 14.6787C7.33909 14.8922
        7.6097 15.3091 7.7041 15.5195L7.83301 15.8086L8.13477 15.7129C9.26098 15.3535
        10.2403 14.8718 11.0869 14.2373C11.9159 14.8909 12.9153 15.3843 14.1182
        15.6943L14.3906 15.7646L14.5205 15.5156C14.6513 15.266 14.9309 14.8532
        15.127 14.6553L15.5771 14.2012L14.9531 14.0605C13.9511 13.8352 13.1064
        13.4653 12.3984 12.9814C12.9878 12.2684 13.4683 11.4377 13.8438
        10.4668H15.2295V8.64551H11.333V10.4668ZM2.125 1.20801C1.74928 1.20801
        1.38872 1.35737 1.12305 1.62305C0.85737 1.88872 0.708008 2.24928 0.708008
        2.625V10.0625C0.708008 10.4382 0.857371 10.7988 1.12305 11.0645C1.38872
        11.3301 1.74928 11.4795 2.125 11.4795H9.5625C9.93822 11.4795 10.2988
        11.3301 10.5645 11.0645C10.8301 10.7988 10.9795 10.4382 10.9795
        10.0625V2.625C10.9795 2.24928 10.8301 1.88872 10.5645 1.62305C10.2988
        1.35737 9.93822 1.20801 9.5625 1.20801H2.125ZM6.28418 4.04199L7.99121
        8.64551H7.51367L7.13379 7.52051L7.05176 7.2793H4.5752L4.49316 7.52051L4.11328
        8.64551H3.69727L5.41211 4.04199H6.28418ZM5.45605 4.59082L4.73438 6.73926L4.57812
        7.20605H7.05762L6.90137 6.73926L6.17969 4.59082L6.09863 4.34863H5.53711L5.45605 4.59082Z"
        fill="#F7F8FD"
        stroke="#F7F8FD"
        stroke-width="0.708333"
      />
    </g>
    <defs>
      <clipPath id="clip0_9258_104830">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
